import type { JSX } from 'react'

export const DiscoverySolidIcon = (): JSX.Element => (
  <use href='#discoverySolidIcon' height='100%' width='100%' />
)
